import { GroupsApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { GROUPS_API_URL } = process.env;

export default new GroupsApi(
  GROUPS_API_URL,
  {
    fromAdmin: true,
  },
  olyEngineApi,
);
